import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Svg5258 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 300,
	height: 281,
	viewBox: "0 0 300 281",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7.896 162.965C-14.5972 110.617 12.6136 50.9008 68.5995 29.6196L126.638 7.56399C182.661 -13.7297 246.324 11.4793 268.805 63.8019L292.105 118.035C314.598 170.389 287.381 230.099 231.395 251.38L173.357 273.436C117.34 294.73 53.677 269.521 31.1963 217.204L7.896 162.965Z",
			fill: "url(#paint0_linear_4_421)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28 252H31.5",
			stroke: "black",
			strokeWidth: 6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M39.5 252H54.5",
			stroke: "black",
			strokeWidth: 6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M62 252H235",
			stroke: "black",
			strokeWidth: 6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M253.5 252H272",
			stroke: "black",
			strokeWidth: 6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 87,
			y: 45.9999,
			width: 126,
			height: 206,
			rx: 9,
			stroke: "black",
			strokeWidth: 6
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M135.711 35.1621C136.824 33.4942 138.697 32.4926 140.702 32.4926L159.269 32.4926C161.274 32.4926 163.146 33.4942 164.259 35.1621L166.252 38.1474C168.912 42.1346 166.054 47.4779 161.261 47.4779L138.71 47.4779C133.916 47.4779 131.058 42.1346 133.719 38.1474L135.711 35.1621Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 98,
			y: 141,
			width: 112,
			height: 108,
			rx: 6,
			fill: "url(#paint1_linear_4_421)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M127.099 93.749C124.473 92.5268 121.289 92.1998 118.112 93.0511C114.935 93.9025 112.341 95.7774 110.678 98.1489",
			stroke: "black",
			strokeWidth: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M189.322 98.1488C187.659 95.7773 185.065 93.9024 181.888 93.051C178.711 92.1997 175.527 92.5267 172.901 93.7489",
			stroke: "black",
			strokeWidth: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M173 155C168.884 158.526 159.24 161 148 161C136.76 161 127.116 158.526 123 155",
			stroke: "black",
			strokeWidth: 6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 113,
			y1: 115,
			x2: 133,
			y2: 115,
			stroke: "black",
			strokeWidth: 6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 167,
			y1: 115,
			x2: 187,
			y2: 115,
			stroke: "black",
			strokeWidth: 6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 128,
			cy: 118,
			r: 4,
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 181,
			cy: 118,
			r: 4,
			fill: "black"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_4_421",
			x1: 150,
			y1: 0,
			x2: 150,
			y2: 281,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#EDEDED" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#EDEDED",
				stopOpacity: .4
			})]
		}), /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_4_421",
			x1: 154,
			y1: 141,
			x2: 154,
			y2: 249,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FEE029" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#F2B719"
			})]
		})] })
	]
});
export default Svg5258;
